import "../styles/App.scoped.css";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import RouteContent from "../routes/RouteContent";
import { BrowserRouter as Router } from "react-router-dom";
//import Facebook from "../components/Facebook/Facebook";
import ReactGA from "react-ga4";
import Tracker from "../components/Tracker/Tracker";
import ScrollUp from "../components/ScrollUp/ScrollUp";

const TRACKING_ID = "G-N9JFEDB3MZ";
ReactGA.initialize(TRACKING_ID);

interface AppProps {}

const App: React.FC<AppProps> = ({}) => {
  return (
    <div className="App">
      <Router>
        {/* <Facebook /> */}
        <Tracker>
          <Header />
          <RouteContent />
          <ScrollUp />
          <Footer />
        </Tracker>
      </Router>
    </div>
  );
};

export default App;
